/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import { ThemeType } from "./Theme/Theme";

export function getTooltipOverrides(theme: ThemeType): any {
  return {
    Body: {
      style: {
        zIndex: 10000, // tooltip should appear on top
      },
    },
    Inner: {
      style: {
        zIndex: 1200,
        border: `1px solid ${theme.colors.primaryLight}`,
        fontSize: theme.fontSizes.small,
        backgroundColor: theme.colors.tooltipBackground,
        color: theme.colors.tooltipText,
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        borderRadius: "4px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        fontFamily: theme.fonts.primary,
      },
    },
    Arrow: {
      style: {
        border: `1px solid ${theme.colors.primaryLight}`,
        borderRadius: "4px",
        backgroundColor: theme.colors.tooltipBackground,
      },
    },
  };
}
